module.exports = __webpack_public_path__ + "img/5_newYouth_fyr.234ae2f6.png";